<template>
    <div class="mt-0">
                    <div class="row borderBottom">
                        <div class="col-lg-12">

                                <h5>Customer Type</h5>

                        </div>
                    </div>

                    <div>
                        <div>
                        <div class="form-body">

                            <div class="row">
                                <div class="col-md-6 col-12 mb-2">
                                <div class="form-label-group mb-0">
                                <strong><span class="text-danger">*</span> Select Customer type</strong>
                                <div class="d-flex">
                                    <div class="form-check mr-2">
                                    <label class="form-check-label">
                                        <input type="radio" required class="form-check-input clickable" value="existing" v-model="customer_type" name="customer_type" style="width:inherit;">Existing Customer
                                    </label>
                                    </div>
                                    <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="radio" required class="form-check-input clickable" value="new" v-model="customer_type" name="customer_type" style="width:inherit;"> New Customer
                                    </label>
                                    </div>
                                </div>

                                </div>
                                </div>
                            </div>

                            <div class="row" v-if="customer_type">
                                <div class="col-md-6 col-12 " v-if="customer_type=='existing'">
                                <div class="form-label-group">
                                <strong><span class="text-danger">*</span> Select Customer</strong>
                                <Select2
                                 v-model="customer.id" @change="$emit('customer_changed', customer.id)"
                                :settings="{ placeholder: 'Select Customer', name:'select_customer' , ajax:ajaxSettings}" required

                                />
                                </div>
                                </div>
                                <template v-if="customer_type=='new'">
                                <div class="col-md-6 col-12 ">
                                <div class="form-label-group">
                                    <label for=""><span class="text-danger">*</span> First Name </label>
                                    <input
                                    type="text"
                                    name="first_name"
                                    required
                                    placeholder="*First Name"
                                    maxlength="100"
                                    v-model="customer.first_name"
                                    class="form-control"
                                    />
                                </div>
                                </div>
                                <div class="col-md-6 col-12">
                                <div class="form-label-group">
                                    <label for=""><span class="text-danger">*</span> Last Name </label>
                                    <input
                                    type="text"
                                    name="last_name"
                                    required
                                    placeholder="*Last Name"
                                    maxlength="100"
                                    v-model="customer.last_name"
                                    class="form-control"
                                    />
                                </div>
                                </div>
                                 <!-- <div class="col-md-6 col-12">
                                <div class="form-label-group">
                                    <label> Phone Number </label>
                                    <input
                                    type="text"
                                    name="phone"
                                    placeholder="Phone Number"
                                    maxlength="100"
                                    v-model="customer.phone"
                                    class="form-control"
                                    />
                                </div>
                                </div> -->
                                <div class="col-md-6 col-12">
                                <div class="form-label-group">
                                    <label for="">Business Name </label>
                                    <input
                                    type="text"
                                    name="business_name"
                                    placeholder="Business Name"
                                    maxlength="100"
                                    required
                                    v-model="customer.name"
                                    class="form-control"
                                    />
                                </div>
                                </div>
                                <div class="col-md-6 col-12 ">
                                <div class="form-label-group">
                                    <label for=""><span class="text-danger">*</span> Email </label>
                                    <input
                                    type="email"
                                    name="email"
                                    required
                                    placeholder="*Email"
                                    v-model="customer.email"
                                    class="form-control"
                                    />
                                </div>
                                </div>
                                <div class="col-md-6 col-12">
                                <div class="form-label-group">
                                    <label for="">Password </label>
                                    <input
                                    type="password"
                                    name="password"
                                    v-model="customer.password"
                                    placeholder="Password"
                                    minlength="8"
                                    class="form-control"
                                    />
                                </div>
                                </div>

                                <div class="col-md-6 col-12">
                                <div class="form-label-group">
                                    <label for="">Phone Number</label>
                                    <telephone ref="tel" v-model="customer.phone" ></telephone>
                                </div>
                                </div>
                                </template>
                            </div>

                        </div>
                        </div>
                    </div>

    </div>
</template>

<script>
import Select2 from 'v-select2-component';
import helpers from './../../reusable-mixins/helpers';
import telephone from '../Telephone.vue'
    export default {
        mixins: [helpers],
        components: {Select2,telephone},
        props:{
            customer_id:{default:''},
            },
        created(){
            let vm=this;
            axios.get(`/${vm.user_type}/customers/get-details`)
                .then(function (response) {

                vm.customers_data = $.map(response.data.data, function (obj) {
                obj.id = obj.id;
                obj.text = 'Name: '+obj.first_name+' '+obj.last_name+', Business Name: '+vm.$options.filters.defaultValue(obj.name)+', Phone Number: '+vm.$options.filters.defaultValue(obj.phone);
                return obj;
                });
                })
                .catch(function (errors) {
                    console.log(errors);
                    vm.showErrorMessage('Someting Went wrong.');
                });

            if(this.notEmpty(this.customer_id)){
                this.customer_type='existing';
            }
        },

        watch: {
            customer_type: function (val) {
            this.$emit('type_changed', val);

                if(val=='new'){
                    this.customer.id='';
                }
            },
            customer_id: function (val) {
                this.customer.id=val;
            },
        },
        computed:{
         ajaxSettings:function(){
            let vm=this;
            return {
                delay: 250,
                url:function(){
                    return `/${vm.user_type}/ticket/get-all-customer`
                },
                data: function (params) {
                    var query = {
                        search: params.term,
                        page: params.page || 1
                    }

                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function (data, params) {
                    params.page = data.current_page || 1;

                    // vm.allCustomers=data.data;
                    vm.allCustomers = [];
                    $.each(data.data,function(index,item){
                vm.allCustomers.push({id:item.id,text: 'Name: '+item.first_name+' '+item.last_name+' , '+'Business Name: '+(item.name? item.name:'N/A')})
            });

                    return {
                        results:  vm.allCustomers,
                        pagination: {
                            more: (data.next_page_url==null? false: true)
                        }
                    };
                }
            }
        },




        },

        data() {
            return {
                customers_data:[],
                customer_type:null,
                allCustomers:[],
                customer:{
                    id:this.customer_id,
                    first_name:'',
                    last_name:'',
                    name:'',
                    email:'',
                    password:'',
                    phone:null,
                },
            };
        },
    }
</script>
